import React from 'react';
import * as Styled from './ViewFinder.styles';

export const ViewFinder = () => (
  <Styled.ViewFinderContainer>
    <Styled.ViewFinderTop />
    <Styled.ViewFinderBottom />
  </Styled.ViewFinderContainer>
);
